import React, { useRef } from 'react';
import Destinations from './components/Destinations';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Search from './components/Search';
import Selects from './components/Selects';
import ScrollTop from './components/ScrollTop'
import {Helmet} from "react-helmet";

function App() {
  const mainRef = useRef(null); 
  const aboutRef = useRef(null);
  const usageRef = useRef(null);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>BaliFather</title>
        <meta name="description" content="BaliFather" />
      </Helmet>
      <Navbar mainRef={mainRef} aboutRef={aboutRef} usageRef={usageRef}/>
      <Hero />
      <Destinations mainRef={mainRef} />
      <Search aboutRef={aboutRef} />
      <Selects usageRef={usageRef} />
      <Footer />
      <ScrollTop />
    </div>
  );
}

export default App;
